var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#dd4b64;}.a{opacity:0.198;}.b{fill:#121b45;}.d{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 80,
    cy: 80,
    r: 80
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.025 37.573)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2741.571,868.552l20.563,12.337-.071,23.905L2741.571,892.9Z",
    transform: "translate(-2741.571 -819.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2772.152,901.85l30.439-17.574V859.629l-30.368,18.316Z",
    transform: "translate(-2751.66 -816.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2883.551,868.471,2862.9,880.862l.071,23.905,20.581-11.948Z",
    transform: "translate(-2781.601 -819.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2848.018,901.85l-30.439-17.574V859.629l30.368,18.316Z",
    transform: "translate(-2766.648 -816.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2741.571,844.617l20.563,12.337,30.368-18.316,30.368,18.316,20.652-12.392-30.572-18.526,30.274-17.749-20.277-12.07-30.374,17.547L2762.514,796l-20.508,12.247,30.273,17.759Z",
    transform: "translate(-2741.571 -796.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2878.369,838.291V814.334L2848.1,832.083l20.291,12.3Z",
    transform: "translate(-2776.717 -802.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2742.22,838.239V814.282l30.274,17.749-20.292,12.3Z",
    transform: "translate(-2741.785 -802.035)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3fd7bdc23a0ca1fd687d1a8093386233.svg";
export { ForwardRef as ReactComponent };